
import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-terms-condition',
  templateUrl: './terms-condition.component.html',
  styleUrl: './terms-condition.component.scss'
})
export class TermsConditionComponent implements OnInit {
  constructor(
    private titleService: Title,
    private metaService: Meta,
     @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit(): void {
      if (isPlatformBrowser(this.platformId)) {
    this.setSeoMeta();
    this.setSchema();

  }
  }

  setSeoMeta() {
    this.titleService.setTitle($localize`:@@TERMS_CONDITION.TITLE:Terms and Conditions | Vanuston Intelligence `);

    this.metaService.updateTag({
      name: 'description',
      content: $localize`:@@TERMS_CONDITION.DESCRIPTION:Review Vanuston Intelligence's Terms and Conditions to understand your rights, responsibilities, and our commitment to secure, reliable software.`,

    });  

    this.metaService.updateTag({
      name: 'keywords',
      content: $localize`:@@TERMS_CONDITION.KEYWORDS:Vanuston software terms of service, Enterprise software usage policy 2025, Vanuston licensing and user agreement, Secure enterprise software compliance, Vanuston Intelligence legal policy, Business software terms and conditions, Vanuston user data protection policy, Enterprise SaaS agreement Vanuston, User rights and software access terms, Reliable healthcare software contract, Vanuston GDPR-compliant software terms, Software subscription agreement Vanuston, Enterprise software data security policy, Vanuston software usage compliance, Software end-user responsibilities 2025`
    });

    this.metaService.updateTag({
      property: 'og:title',
      content: $localize`:@@TERMS_CONDITION.OG_TITLE:Terms and Conditions | Vanuston Intelligence`
    });

    this.metaService.updateTag({
      property: 'og:description',
      content: $localize`:@@TERMS_CONDITION.OG_DESCRIPTION:Review the Terms and Conditions for using Vanuston Intelligence's software and services.`
    });

    this.metaService.updateTag({
      property: 'og:url',
      content: 'https://www.vanuston.com/terms-condition'
    });

    this.metaService.updateTag({
      property: 'og:type',
      content: 'website'
    });
  }

  setSchema() {
    const schema = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": $localize`:@@TERMS_CONDITION.SCHEMA_NAME:Terms and Conditions`,
      "url": "https://www.vanuston.com/terms-condition",
      "description": $localize`:@@TERMS_CONDITION.SCHEMA_DESCRIPTION:Review the Terms and Conditions for using Vanuston Intelligence's software and services.`,
      "publisher": {
        "@type": "Organization",
        "name": "Vanuston Intelligence",
        "url": "https://www.vanuston.com",
        "logo": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png"
      }
    };

    const script = document.createElement('script');
    script.setAttribute('type', 'application/ld+json');
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
  }
}






// import { Component, OnInit } from '@angular/core';
// import { Meta, Title } from '@angular/platform-browser';

// @Component({
//   selector: 'app-terms-condition',
//   templateUrl: './terms-condition.component.html',
//   styleUrl: './terms-condition.component.scss'
// })
// export class TermsConditionComponent implements OnInit {
//   constructor(private titleService: Title, private metaService: Meta) {}

//   ngOnInit(): void {
//     this.setSeoMeta();
//     this.setSchema();
//   }

//   setSeoMeta() {
//     this.titleService.setTitle('Terms and Conditions | Vanuston Intelligence - Your Trusted Software SaaS Partner');
//     this.metaService.updateTag({ name: 'description', content: 'Review the Terms and Conditions for using Vanuston Intelligence\'s software and services. Understand your rights, responsibilities, and our commitment to delivering secure and reliable solutions.' });
//     this.metaService.updateTag({ name: 'keywords', content: 'Vanuston Terms and Conditions, Software usage policy, Enterprise software agreement, Legal terms for Vanuston Intelligence, Software licensing agreement, User responsibilities and rights, Secure software solutions' });
//     this.metaService.updateTag({ property: 'og:title', content: 'Terms and Conditions | Vanuston Intelligence' });
//     this.metaService.updateTag({ property: 'og:description', content: 'Review the Terms and Conditions for using Vanuston Intelligence\'s software and services.' });
//     this.metaService.updateTag({ property: 'og:url', content: 'https://www.vanuston.com/terms-condition' });
//     this.metaService.updateTag({ property: 'og:type', content: 'website' });
//   }

//   setSchema() {
//     const schema = {
//       "@context": "https://schema.org",
//       "@type": "WebPage",
//       "name": "Terms and Conditions",
//       "url": "https://www.vanuston.com/terms-condition",
//       "description": "Review the Terms and Conditions for using Vanuston Intelligence's software and services.",
//       "publisher": {
//         "@type": "Organization",
//         "name": "Vanuston Intelligence",
//         "url": "https://www.vanuston.com",
//         "logo": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png"
//       }
//     };

//     const script = document.createElement('script');
//     script.setAttribute('type', 'application/ld+json');
//     script.textContent = JSON.stringify(schema);
//     document.head.appendChild(script);
//   }

// }
